module.exports = __webpack_public_path__ + "static/kw51_img_6-fd9df4045086910b8eb038fd61c137e9.png";